import { GetterTree } from 'vuex';
import { PartiesState, PartyPaginator } from './types';
import { RootState } from '@/types';

export const getters: GetterTree<PartiesState, RootState> = {
    parties(state): PartyPaginator | undefined {
        const parties  = state.data || undefined;
        return parties;
    },
};
